import { useStoreLocationWidget } from '../hooks/useStoreLocationWidget';
import storeWidgetBg from '@/shared/assets/images/bp-store-widget.jpg';

function buildMapsUrl(destinationPlaceId: string, latitude: string, longitude: string): string {
  if (destinationPlaceId) {
    return `https://www.google.com/maps/search/?api=1&query=BlueStone+Jewellery&query_place_id=${destinationPlaceId}`;
  }
  if (latitude && longitude) {
    return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  }
  return '';
}

export function StoreLocationWidget({ pincode }: { pincode?: string }) {
  const { data, isLoading, suppressed } = useStoreLocationWidget(pincode);

  if (suppressed) return null;

  if (isLoading) {
    return (
      <div className="flex w-full overflow-hidden rounded-md animate-pulse" style={{ minHeight: 220 }}>
        <div className="w-2/5 bg-gray-300/60" />
        <div className="w-3/5 bg-gray-200/60" />
      </div>
    );
  }

  if (!data) return null;

  const { nearestStore, storeImageUrl } = data;
  const mapsUrl = buildMapsUrl(nearestStore.destinationPlaceId, nearestStore.latitude, nearestStore.longitude);

  return (
    <div className="flex w-full overflow-hidden rounded-md" style={{ minHeight: 220 }}>
      {/* Left: 40% — background image panel with text + button */}
      <div
        className="flex w-2/5 flex-col items-start justify-center gap-3 px-6 py-6"
        style={{
          backgroundImage: `url(${storeWidgetBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <p className="text-sm font-semibold leading-snug text-white md:text-lg">
          {nearestStore.storeMessage}
        </p>
        {mapsUrl ? (
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-block px-3 py-1.5 text-xs font-medium text-white md:px-4 md:py-2 md:text-sm"
            style={{ border: '1px solid white' }}
          >
            Get Direction
          </a>
        ) : (
          <a
            href="/store.html"
            className="mt-1 inline-block px-3 py-1.5 text-xs font-medium text-white md:px-4 md:py-2 md:text-sm"
            style={{ border: '1px solid white' }}
          >
            Know More
          </a>
        )}
      </div>

      {/* Right: 60% — store photo */}
      {storeImageUrl ? (
        <div className="w-3/5 overflow-hidden">
          <img
            src={storeImageUrl}
            alt="BlueStone store"
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="w-3/5 bg-gray-100" />
      )}
    </div>
  );
}
